export default "<header>\n    <div class=\"title\">Apertura de siniestros por parte de Ingesport</div>\n</header>"